import React, { useMemo, useState } from 'react'

import { useLocation } from 'react-router-dom'

import PropTypes from 'prop-types'

import CategoriesTabs from './CategoriesTabs'
import MetaDataHelmet from '../../../Shared/MetaDataHelmet'

function CategoriesPage({ competitionSlug }) {
  const location = useLocation()

  const tabsArr = useMemo(
    () => I18n.t(`competition.${competitionSlug}.categories.tabs`),
    [competitionSlug],
  )

  const [activeTabSlug] = useState(() => (
    location.state != null ? location.state.activeSectionSlug : tabsArr[0].slug
  ))

  const metaTitle = I18n.t(`competition.${competitionSlug}.meta.title.categories`)
  const metaDescription = I18n.t(`competition.${competitionSlug}.meta.description.categories`)
  const pageDescription = I18n.t(`competition.${competitionSlug}.categories.page_description`)

  return (
    <div className="competition-categories-page">
      <MetaDataHelmet title={metaTitle} description={metaDescription} />

      <section className="content-section section--categories">
        <div className="container-fixed">
          <h2 className="content-section__title">Categories & Prizes</h2>
          <p className="content-section__subtitle">{pageDescription}</p>

          <CategoriesTabs activeTabSlug={activeTabSlug} tabs={tabsArr} competitionSlug={competitionSlug} />
        </div>
      </section>
    </div>
  )
}

CategoriesPage.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
}

export default CategoriesPage
